import '../App.sass';

interface Properties {
  title: string;
  className?: string;
  color?: string;
  value: string;
  unit?: string;
}

export default function Metric(properties: Properties) {
  const getComputedColor = (colorValue?: string) => {
    if (!colorValue) return undefined;
    
    // If it's a CSS variable, get its computed value
    if (colorValue.startsWith('var(--')) {
      const variableName = colorValue.replace('var(--', '').replace(')', '');
      const computedStyle = getComputedStyle(document.documentElement);
      return computedStyle.getPropertyValue(`--${variableName}`).trim();
    }
    
    return colorValue;
  };

  const computedColor = getComputedColor(properties.color);

  return <div className={`${properties.className ? properties.className + ' ' : ''}displayFlex flexDirectionColumn alignItemsCenter width150`}>
    <div className='textS' style={{ color: computedColor }}>{properties.title}</div>
    <div className='displayFlex alignItemsBaseline gapXS'>
      <span className='textXL fontWeightBold' style={{ color: computedColor }}>{properties.value}</span>
      {properties.unit
        ?
        <span className='textL fontWeightBold' style={{ color: computedColor }}>{properties.unit}</span>
        :
        <></>}
    </div>
  </div>;
}
